import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { tariffTypes } from 'services/types';
import { Help } from 'libs/ui';
import { InputWithHelp } from 'libs/ui';
import { ParkingFilter2, required, MultiselectView, StyledField, DarkMultiselect, Toggle, minValue, maxValue } from 'libs/form';
import { SectionTitle, TwoFields } from './tariff-form-main.styled';

export const TariffFormMain = (props) => {
  const { t } = useTranslation();
  const validateP = useCallback(required(t), [t]);
  const minValue1 = useCallback(minValue(t, 1), [t]);
  const maxValue99 = useCallback(maxValue(t, 99), [t]);

  const { type, disabled, vehicleClasses, categories, oldTimeFrom } = props;

  //const withSubscriptionPeriod = initialValue.subscription_period !== undefined;
  // const withSecondEntry = initialValue.data.secondentry_amount !== undefined;
  // const withSecondEntry = initialValue.data.secondentry_period !== undefined;

  if (!['individual', 'basic1', 'basic2', 'basic3', 'basic4'].includes(type)) {
    return null;
  }
  const isIndividual = type === 'individual';
  const timeLimit = props.initialValue.data.time_limit;
  const withTimeLimit = timeLimit !== undefined && timeLimit !== null;

  /**
   * get type options
   * @returns
   */
  const getTypeOptions = () => {
    return tariffTypes.map((type) => {
      return (
        <option key={type.id} value={type.id}>
          {type.name}
        </option>
      );
    });
  };

  /**
   * limit date by current for dependance tariffs
   * @param {*} current
   * @returns
   */
  const disabledDate = (current) => {
    if (!oldTimeFrom) {
      return false;
    }
    return current.isSameOrBefore(oldTimeFrom, 'hour');
  };

  return (
    <>
      <StyledField noApperance validate={validateP} type="select" label={t('dict_filter.Тип')} name="type" disabled={true}>
        {getTypeOptions()}
      </StyledField>
      {isIndividual && (
        <>
          <ParkingFilter2 dark disabled={true} />
          <StyledField validate={validateP} placeholder={t('grid.Осень 2017')} type="text" label={t('grid.Название *')} name="name" disabled={disabled} />
          <DarkMultiselect
            validate={validateP}
            type="multiselect"
            label={t('form.Класс ТС *')}
            name="vehicle_class"
            placeholder={t('form.Выберите класс ТС')}
            disabled={disabled}
            data={vehicleClasses}
            additionalComponent={MultiselectView}
            autoWidth={false}
          />
          <DarkMultiselect
            type="multiselect"
            label={t('form.Категория')}
            name="vehicle_category"
            placeholder={t('form.Выберите категорию ТС')}
            disabled={disabled}
            data={categories}
            additionalComponent={MultiselectView}
            autoWidth={false}
          />
        </>
      )}
      <StyledField
        className="shortfield"
        validate={validateP}
        placeholder={t('form.08 11 2017')}
        type="dateTime"
        label={t('form.Начало *')}
        name="time_from"
        disabled={disabled}
        disabledDate={disabledDate}
      />
      <StyledField type="text" placeholder={t('form.15 мин')} label={t('form.Время на выезд')} name="time_to_leave" mask={{ suffix: t('form.мин') }} disabled={disabled} />
      <SectionTitle>{t('sections.Абонемент')}</SectionTitle>
      <StyledField
        type="text"
        placeholder={t('form.Цена абонемента')}
        label={t('form.Цена абонемента')}
        name="subscription_amount"
        mask={{ suffix: t('form.руб') }}
        disabled={disabled}
      />

      <TwoFields>
        <StyledField type="text" placeholder={'30'} label={t('form.Срок действия')} name="subscription_period" mask={{ suffix: '' }} disabled={disabled} />
        <StyledField type="select" label="" name="subscription_period_unit" onlyInput disabled={disabled}>
          <option value="days">{t('units.дней')}</option>
          <option value="months">{t('units.месяцев')}</option>
        </StyledField>
      </TwoFields>
      {withTimeLimit && (
        <StyledField
          type="text"
          placeholder={t('form.15 мин')}
          label={t('form.Лимит времени')}
          name="time_limit"
          mask={{ suffix: t('form.мин') }}
          naturalNumber
          disabled={disabled}
        />
      )}

      <>
        <SectionTitle>{t('form.Повторный въезд')}</SectionTitle>
        <StyledField
          type="text"
          placeholder={t('form.15 мин')}
          label={t('form.Повторный платный въезд')}
          name="secondentry_interval"
          mask={{ suffix: t('form.мин') }}
          disabled={disabled}
        />
      </>

      {!isIndividual && (
        <>
          <InputWithHelp className="inVerticalForm">
            <StyledField
              type="text"
              placeholder={''}
              mask={{ suffix: ' ' + t('tariffs.парковочных сессий') }}
              label={t('tariffs.Порог срабатывания')}
              min={1}
              max={99}
              naturalNumber
              validate={[minValue1, maxValue99]}
              name="secondentry_count_min"
              disabled={disabled}
            />
            <Help className="white" info={t('tariffs.Порог срабатывания помощь')} />
          </InputWithHelp>
          <InputWithHelp className="inVerticalForm">
            <StyledField
              type="text"
              placeholder={t('form.15 сек')}
              label={t('tariffs.Продолжительность парковки для отключения')}
              name="secondentry_duration_max"
              mask={{ suffix: t('form.мин') }}
              disabled={disabled}
            />
            <Help className="white" info={t('tariffs.Продолжительность парковки для отключения помощь')} />
          </InputWithHelp>
          <InputWithHelp className="inVerticalForm">
            <Toggle className="black in-tariff" label={t('tariffs.Режим продления санкций')} name="secondentry_use_previous" type="toggle" disabled={disabled} />
            <Help className="white" info={t('tariffs.Режим продления санкций помощь')} />
          </InputWithHelp>

          <StyledField
            type="text"
            placeholder={t('form.руб')}
            label={t('form.Цена первого периода')}
            name="secondentry_amount"
            mask={{ suffix: t('form.руб') }}
            disabled={disabled}
          />
          <StyledField type="text" placeholder={t('form.15 сек')} label={t('grid.Первый период')} name="secondentry_period" mask={{ suffix: t('form.мин') }} disabled={disabled} />
          <StyledField
            type="text"
            placeholder={t('form.15 сек')}
            label={t('form.Отмена платного периода')}
            name="secondentry_duration"
            mask={{ suffix: t('form.мин') }}
            disabled={disabled}
          />
        </>
      )}
    </>
  );
};
